export const POINTS_SET = 'POINTS_SET';
export const POINTS_TRIGGER_BOUNCE = 'POINTS_TRIGGER_BOUNCE';
export const POINTS_CLEAR_BOUNCE = 'POINTS_CLEAR_BOUNCE';